import { render, staticRenderFns } from "./Subreddits.vue?vue&type=template&id=5fad9bd4&"
import script from "./Subreddits.vue?vue&type=script&lang=js&"
export * from "./Subreddits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports